export interface WizardSidebarRow {
  label: string
  value: string
}

export interface WizardSidebarStatus {
  /** Display text for the badge. */
  label: string
  /** Tailwind classes for the badge background/text colour. */
  className: string
}

interface Props {
  rows: WizardSidebarRow[]
  status?: WizardSidebarStatus | null
  /** Sidebar width utility class. Defaults to `w-80`. */
  width?: string
}

/**
 * Flow-agnostic sticky wizard sidebar that renders a list of label/value rows
 * and an optional status badge. Shared by the CT600 and Self-Assessment wizards;
 * each flow maps its own context (company / NINO / tax year, etc.) into `rows`.
 */
export default function WizardSidebar({ rows, status, width = 'w-80' }: Props) {
  return (
    <div className={`${width} flex-shrink-0`}>
      <div className='xl:sticky xl:top-8 space-y-3 text-sm'>
        {rows.map(row => (
          <div key={row.label}>
            <div className='text-gray-500'>{row.label}:</div>
            <div className='font-semibold text-gray-900'>{row.value}</div>
          </div>
        ))}
        {status && (
          <div>
            <div className='text-gray-500'>Status:</div>
            <span
              className={`mt-1 inline-block rounded-full px-3 py-1 text-xs font-medium ${status.className}`}
            >
              {status.label}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
